import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import SpinnerExample from '../examples/Spinner';
const SpinnerExampleSource = require('!!raw-loader!../examples/Spinner');
export default class SpinnerPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Spinner"/>
                <h3>Spinner</h3>
                <div className="docs-example">
                    <SpinnerExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{SpinnerExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>Spinner Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`
type Props = {|
  className?: string,
  color?: 'dark' | 'light',
  size?: 'small' | 'middle',
|};
`}
                        </PrismCode>
                    </pre>
                </div>
            </div>);
    }
}
